import type { EmailContent } from '../types/emailTypes'
import { DEFAULT_SETTINGS } from '../constants'
import { createDefaultEmailBody } from './createDefaultEmailBody'

export function createDefaultEmailContent(): EmailContent {
  return {
    entities: [createDefaultEmailBody()],
    settings: DEFAULT_SETTINGS,
  }
}
